import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";

export default function ContentSection() {
  return (
    <section className="py-16 md:py-32">
      <div className="mx-auto max-w-5xl space-y-8 px-6 md:space-y-12">
        <img
          className="rounded-(--radius) grayscale"
          src="https://images.unsplash.com/photo-1530099486328-e021101a494a?q=80&w=2747&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
          alt="team image"
          height=""
          width=""
          loading="lazy"
        />

        <div className="grid gap-6 md:grid-cols-2 md:gap-12">
          <h2 className="text-4xl font-medium">
            It's time to take back control of your technology
          </h2>
          <div className="space-y-6">
            <p className="text-muted-foreground">
              Close down common loopholes that allow content filtering to be
              bypassed, whether you're managing a device for a teen,
              accountability partner, or yourself. Our multi-layered approach ensures
              comprehensive protection across all devices and platforms.
            </p>

            <Button
              asChild
              variant="secondary"
              size="lg"
              className="gap-1 pr-1.5"
            >
              <a href="/auth">
                <span>Start Protecting Your Family</span>
                <ChevronRight className="size-2" />
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
